import {$hubspot} from "@/services/hubspot/hubspot-api";

export function hubspotApiPlugin() {
    return {
        $hubspot: $hubspot
    }
}